// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"8a4bbfeb","282":"bd5fd33c","477":"b66c8711","826":"38c63208"}[chunkId] + ".chunk.js";
};